module.exports = __webpack_public_path__ + "static/media/SupplyChain4.ebe723d7.png";